(function () {
  'use strict';

  var STORAGE_KEY = 'alliance_recent_products_v1';
  var MAX_STORED = 8;
  var MAX_SHOWN = 4;

  function read() {
    try {
      var value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_) {
      return [];
    }
  }

  function write(products) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(products.slice(0, MAX_STORED)));
    } catch (_) {
      /* Recently viewed remains optional when storage is unavailable. */
    }
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(Number(cents || 0) / 100);
    } catch (_) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function createCard(product) {
    var article = document.createElement('article');
    article.className = 'recent-product-card';

    var media = document.createElement('a');
    media.className = 'recent-product-card__media';
    media.href = product.url;
    media.setAttribute('aria-label', product.title);
    if (product.image) {
      var image = document.createElement('img');
      image.src = product.image;
      image.alt = product.title;
      image.loading = 'lazy';
      media.append(image);
    }

    var body = document.createElement('div');
    body.className = 'recent-product-card__body';
    var vendor = document.createElement('p');
    vendor.className = 'recent-product-card__vendor';
    vendor.textContent = product.vendor || '';
    var heading = document.createElement('h3');
    var link = document.createElement('a');
    link.href = product.url;
    link.textContent = product.title;
    heading.append(link);

    var commerce = document.createElement('div');
    commerce.className = 'recent-product-card__commerce';
    var price = document.createElement('div');
    price.className = 'recent-product-card__price';
    var current = document.createElement('strong');
    current.textContent = money(product.price, product.currency);
    price.append(current);
    if (Number(product.compareAt || 0) > Number(product.price || 0)) {
      var compare = document.createElement('s');
      compare.textContent = money(product.compareAt, product.currency);
      price.append(compare);
    }
    var status = document.createElement('a');
    status.className = 'button recent-product-card__status';
    status.href = product.url;
    status.setAttribute('aria-label', 'View details for ' + product.title);
    status.textContent = 'View details';
    commerce.append(price, status);
    body.append(vendor, heading, commerce);
    article.append(media, body);
    return article;
  }

  document.querySelectorAll('[data-recent-products]').forEach(function (section) {
    var data = section.querySelector('[data-recent-product-current]');
    var grid = section.querySelector('[data-recent-products-grid]');
    if (!grid) return;

    var current = null;
    if (data) {
      try {
        current = JSON.parse(data.textContent);
      } catch (_) {
        current = null;
      }
    }

    var stored = read().filter(function (item) {
      return item && item.handle && (!current || item.handle !== current.handle);
    });
    stored.slice(0, MAX_SHOWN).forEach(function (item) {
      grid.append(createCard(item));
    });
    if (grid.children.length) section.hidden = false;

    if (current && current.handle) write([current].concat(stored));
  });
})();
